/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { CrossIconContainer, StyledDialogTitle, StatusContainer } from "./styles";
import ClearIcon from '@mui/icons-material/Clear';
import camelize from "../../utils/camelize";
import { IndexTable } from "../index_table";
import { MODAL_TABLE_MAX_HEIGHT } from "../index_table/styles";
import { Loader } from "../loader";
import { formatDate } from "../../utils/formatDate";
import { auditModuleDisplayName } from "../../constants/auditLogModules";

export const AuditLogModal = ({ open, setOpen, moduleName, auditRow, isLoading }) => {
  const handleClose = () => {
    setOpen(false)
  }

  const splitCamelCase = (str) => {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  const formatReason = (reason) => {
    if(reason) {
      const formattedReason = reason.split('rb:')
      return formattedReason[0]
    }
    else {
      return 'NA'
    }
  }

  const tableColumns = [
    "performed_at",
    "restaurant",
    "event_type",
    "status",
    "duration",
    "no_of_retries",
    "jid",
    "reason",
  ];

  const columns = tableColumns?.map((column) => {
    return {
      key: column,
      label: camelize(column),
    };
  });

  const TableRows = (data) => {
    return data?.map((record) => {
      return {
        performed_at: formatDate(record?.created_at, record?.time_zone_abbr),
        restaurant: record?.restaurant_name,
        event_type: splitCamelCase(record?.worker_name),
        status: (
          <StatusContainer status={record?.status}>
            {camelize(record?.status)}
          </StatusContainer>
        ),
        duration: record?.duration,
        no_of_retries: record?.retry_count,
        jid: record?.jid,
        reason: formatReason(record?.retry_reasons)
      };
    });
  };

  const rows = TableRows(auditRow);

  return (
    <React.Fragment>
      <Dialog
        data-testid="audit-log-modal"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <CrossIconContainer>
          <ClearIcon onClick={handleClose} />
        </CrossIconContainer>
        <StyledDialogTitle data-testid="audit-log-modal-title" sx={{paddingBottom: '10px'}}>
          {`${auditModuleDisplayName(moduleName)} Audit Log Details`}
        </StyledDialogTitle>
        <DialogContent>
          {
            isLoading || auditRow?.length === 0 ? (
              <Loader />
            ) : (
              <IndexTable
                maxHeight={MODAL_TABLE_MAX_HEIGHT}
                columns={columns}
                data={rows || []}
                tableId="audit-log-modal"
                type="entries"
                itemsPerPage={10}
                pageCount={4}
                page={1}
                report={false}
                hideNavigation={true}
              />
            )
          }
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}
